import { Component, OnInit } from '@angular/core';

declare var $: any

@Component({
  selector: 'app-teaching',
  templateUrl: './teaching.component.html',
  styleUrls: ['./teaching.component.scss']
})
export class TeachingComponent implements OnInit {


  list = [
    {
      title: 'BREE 312',
      content: 'Electric Circuits and Machines (3 credits)'
    },
    {
      title: 'BREE 504',
      content: 'Instrumentation and Control (3 credits), Co-teach with Dr. Adamchuk'
    },
    {
      title: 'BREE 501',
      content: 'Simulation and Modelling (3 credits), Co-teach with Dr. Clark'
    }
  ]



  constructor() { }

  ngOnInit(): void {
    $('html, body').animate({ scrollTop: 0 }, 0);
  }

}
